import React from "react";

const yash_shah = () => {
  return (
    <div>
      <h1>Yash Shah</h1>

      <h4>
        <em>
          Computer Engineering, Batch of 27'
          <br />
          <hr />
        </em>
      </h4>

      <p>
        <strong>CSI Internship Diaries 2025</strong>
      </p>

      <p>
        <strong>
          What was the criteria for shortlisting candidates in the initial
          stages of the recruitment process
        </strong>
        ?<br />
        Eligibility Criteria for the Aptitude Test: Candidates with a CGPA above
        7.0 were eligible to appear for the test.
      </p>

      <p>
        <strong>What was the Timeline of the entire Interview Process</strong>?{" "}
      </p>

      <p>The entire interview process followed this timeline:</p>

      <ul>
        <li>
          <p>
            <strong>18th August:</strong> Online PPT and aptitude/online test
            were conducted.
          </p>
        </li>
        <li>
          <p>
            <strong>22nd August:</strong> Results of the online test were
            announced, and shortlisted candidates were informed.
          </p>
        </li>
        <li>
          <p>
            <strong>26th August:</strong> Technical and HR interviews were
            scheduled and conducted.
          </p>
        </li>
        <li>
          <p>
            <strong>Post-HR Round:</strong> Final selections were communicated,
            and all 5 selected candidates were offered positions.
          </p>
        </li>
      </ul>

      <p>
        <strong>What was the Structure of the Aptitude Round?</strong>
        <br />
        The Aptitude Round consisted of multiple sections. It included
        behavioral, situational, audio, video, and vocabulary-related questions,
        along with mental ability and logical reasoning questions. After
        completing these sections, we were given three coding problems to solve:
        one easy-level, one medium-level, and one hard-level question.
      </p>

      <p>
        <strong>
          How many students were shortlisted after the Aptitude Round?
        </strong>
        <br />
        After the aptitude round, approximately 18 students were shortlisted.
      </p>

      <p>
        <strong>
          After being shortlisted, how long was the wait time before the
          interviews began? During this period, what specific areas did you
          focus on to prepare effectively?
        </strong>
        <br />
        The online PPT and test took place on 18th August, and the results for
        the test were announced around 22nd August. My interviews were then
        scheduled for 26th August, which gave me a decent amount of time to
        prepare. During this period, I focused on strengthening the subjects I
        am confident in and that carry high weightage in interviews, ensuring I
        could answer related questions effectively. I also thoroughly reviewed
        my projects and resume, along with gaining some basic insights about the
        company, to be well-prepared for any discussion.
      </p>

      <p>
        <strong>
          How many Interview Rounds were there for the company, can you
          elaborate about each round in brief? Also mention, how many students
          were shortlisted after each Interview Round?
        </strong>
      </p>

      <p>
        The first round was a technical round, where the interviewers primarily
        focused on the details mentioned in my resume. They asked about core
        concepts in DSA, OOPs, and DBMS, along with a few questions about my
        projects to assess my understanding and contributions. In DSA, they
        asked basic questions with follow-up cross-questioning, including
        converting a sorted array to a binary tree, basic insertion and deletion
        operations, and handling duplicates in an array. Additionally, they gave
        a LeetCode easy and a LeetCode medium-level DSA problem. A few puzzles
        and possibly one system design-related question were also included.
      </p>

      <p>
        In the HR round, the focus was mostly on understanding me as an
        individual — my achievements, experiences, and future plans. They asked
        about my involvement in activities, what I have done so far, and what I
        plan to pursue in the future. Basic behavioral questions were asked,
        along with one or two company-related questions, including questions
        about HSBC.
      </p>

      <p>
        In the technical round, around 18 candidates were selected to move
        forward. During the HR round, this number was narrowed down to just 5
        candidates, and ultimately, all 5 of us were offered selection.
      </p>

      <p>
        <strong>
          What Topics or Skills did the interviewers focus on during the
          interviews? (e.g., DSA, Puzzles, DBMS, OS, Networks, System Design, or
          Behavioral questions)
        </strong>
      </p>

      <p>
        During the interview, the focus was primarily on <strong>DSA</strong>,
        where basic questions were asked along with follow-up cross-questioning.
        Some of the questions I remember included converting a sorted array to a
        binary tree, basic insertion and deletion operations, and handling
        duplicates in an array. Apart from this, the interviewers assessed my
        understanding of <strong>OOPs</strong>, particularly inheritance and
        other core concepts. <strong>DBMS</strong> questions were asked in depth
        to evaluate my grasp of database fundamentals. Additionally, a few{" "}
        <strong>puzzles</strong> were included, and there was possibly one
        question related to <strong>system design</strong>.
      </p>

      <p>
        <strong>
          What are some good resources that you used in your Internship Prep?
        </strong>
      </p>

      <p>
        If you’re starting late with DSA prep, the Striver SDE Sheet is a great
        roadmap. If time permits, go through Striver’s A to Z Sheet for
        comprehensive coverage. For core subjects, refer to Gate Smashers, Neso
        Academy, and other quality YouTube channels. Also, make sure you have a
        deep understanding of your projects and all the technologies you’ve used
        — interviewers often focus on these during technical rounds.
      </p>

      <p>
        <strong>Some tips to crack Coding Questions?</strong>
        <br />
        Practice a variety of problems.
        <br />
        I prefer Striver's A2Z DSA playlist
        <br />
        (Try to solve 2-3 LeetCode questions daily.)
      </p>

      <p>
        <strong>
          How many questions were asked about Projects, Clubs, and
          Extracurricular activities in your resume
        </strong>
        ?<br />
        Projects: Only a small portion of my technical interview touched on my
        projects, mainly brief questions to understand my role and
        contributions.
        <br />
        Clubs and Extracurricular Activities: These were mentioned during my
        introduction, and only a short question about what extracurricular
        activities I’m involved in came up during the HR round.
      </p>

      <p>
        <strong>
          Is there something specific that you would want to tell people who are
          preparing for the same company
        </strong>
        ?<br />
        Master OOPs and DBMS Concepts: Confidence in Object-Oriented Programming
        principles and core DBMS concepts is crucial, as these topics carry
        significant weight in the interview process.
      </p>

      <p>
        <strong>Any Final Tips for Juniors?</strong>
      </p>

      <p>
        The internship process can be tiring, hectic, and sometimes
        disheartening. But remember — rejections are part of the journey, and
        opportunities are plentiful. Stay resilient and consistent; if you’ve
        prepared well, the results will eventually follow.
      </p>

      <p>
        <strong>Be Prepared:</strong> Companies often start visiting as soon as
        the 5th semester begins. Use your summer break to get a head start;
        revise your core technical concepts, practice coding daily, and
        strengthen your problem-solving approach.
      </p>

      <p>
        <strong>Be Honest and Confident:</strong> If you don’t know the answer
        to a question, never try to fake it. Instead, be upfront and express
        your willingness to learn. Interviewers value authenticity and
        confidence more than memorized answers.
      </p>

      <p>
        <strong>Don’t Fear Competition:</strong> Remember, most companies
        prioritize finding the <em>right fit</em> over selecting a fixed number
        of candidates.
      </p>

      <p>
        <strong>Acknowledge Luck and Uncertainty:</strong> External factors like
        the interviewer’s domain knowledge, test environment, connectivity
        issues, or even timing can sometimes influence results. Don’t let these
        discourage you. Focus on what’s truly in your control; your preparation,
        clarity, and confidence.
      </p>

      <p>
        Good luck! Stay focused, trust your efforts, and keep pushing forwar;
        your opportunity will come at the right time. 💪
      </p>

      <p>
        <strong>Contact Info </strong>
      </p>

      <p>
        <strong>Email :</strong> <a href="mailto:yashrshah2005@gmail.com">yashrshah2005@gmail.com</a>
        <br />
        <strong>LinkedIn :</strong>
        <a href="https://www.linkedin.com/in/yash-shah-2005/">Yash Shah</a>
      </p>

      <hr />
    </div>
  );
};

export default yash_shah;
